/**
 * Home Credit (https://www.homecredit.vn/)
 *
 * Copyright © 2018-present HomeCredit, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export const FORM_STATUS = {
  INITIAL: 0,
  NEED_VALIDATE: 1,
  ERROR: 2,
  SUCCESS: 3,
};

export const LOADER_STATUS = {
  ON: true,
  OFF: false,
};

export const UPDATE_TOKEN = 'UPDATE_TOKEN';

export const MESSAGES = {
  GLOBAL_ERROR: 'Hệ thống đang được bảo trì. Quý khách vui lòng quay lại sau.',
  OK: 'OK',
  OTP_401:
    'Quý khách chưa có quyền để yêu cầu OTP. Vui lòng liên hệ Admin hệ thống.',
  BOT_DETECTION:
    'Quý khách vui lòng thử lại sau vì hệ thống đang xác nhận có các hoạt động truy cập không phù hợp.',
};

export const CONTENT_TYPES = {
  MULTIPART_FORM: 'MULTIPART/FORM-DATA',
  JSON: 'application/json',
};
